import { useTranslation } from 'react-i18next';
import { ConfirmationDialog, Typography } from '@statsbomb/kitbag-components';
import { Suspense, useState } from 'react';
import { FirstTimeModalWithData } from '@/components/modal/FirstTimeModals/FirstTimeModal';
import { FirstTimeModalTypes } from '@/types/userConfigs';

export const FirstTimeModalFeaturesBase = ({ onConfirm }: { onConfirm: () => void }) => {
  const { t } = useTranslation('modal', { keyPrefix: 'firstTimeModalFeatures' });

  return (
    <ConfirmationDialog
      id="first-time-features-modal"
      title={t('title')}
      isOpen
      onConfirm={onConfirm}
      confirmLabel={t('confirm')}
      testId="first-time-features-modal"
    >
      <div className="w-[680px]">
        <Typography variant="bodyRegular">
          <span className="font-bold">{t('content.0')} </span>
          {t('content.1')}
          <br />
        </Typography>
        <Typography variant="bodyRegular" as="ul" className="list-disc m-6">
          <li>{t('content.2')}</li>
          <li>{t('content.3')}</li>
          <li>{t('content.4')}</li>
        </Typography>
        <Typography variant="bodyRegular">{t('content.5')}</Typography>
      </div>
    </ConfirmationDialog>
  );
};

export const FirstTimeModalFeatures = ({ modalType }: { modalType: FirstTimeModalTypes }) => {
  const [userHasAcknowledgedModal, setUserHasAcknowledgedModal] = useState(false);

  return userHasAcknowledgedModal ? null : (
    <Suspense>
      <FirstTimeModalWithData modalType={modalType}>
        <FirstTimeModalFeaturesBase onConfirm={() => setUserHasAcknowledgedModal(true)} />
      </FirstTimeModalWithData>
    </Suspense>
  );
};
